<div class="centered">
  <div class="error-screen-container">
    <h1 class="mb-s error-screen-title">
      This feature has been removed and is no longer available.
    </h1>
    <div class="mb-m"></div>
  </div>
</div>
